import React from 'react';
import { generateNavURL } from '../../../utils/generateNavURL';

const BottomNav = ({ portalUri, apiNavigationTop }) => {
    const menuLinks = apiNavigationTop?.data ?? [];
    const generateURL = (url) => generateNavURL(url, portalUri);

    return (
        <>
            {menuLinks.map((navigation, levelOneKey) => (
                <React.Fragment key={`top-nav-item-${levelOneKey}`}>
                    <a className='nav-secondary-link' href={generateURL(navigation?.get_url)} {...(navigation?.open_new ? `target="_blank"` : ``)}>
                        {navigation?.name}
                    </a>
                </React.Fragment>
            ))}
        </>
    );
};

export default BottomNav;
